export { BdcTag } from "./pages/bdcTag";
